/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Snigdha <snigdha.dhanireddy@mroads.com>, August 2020
 * @format
 * @flow
 */

import { all, takeLatest } from 'redux-saga/effects';
import { ActionTypes } from '../constants';
import API from '../../requests';
import { callAPI } from './callAPI';

interface deviceDetailsType {
  deviceId: string;
  activationKey: string;
}
interface deviceType {
  payload: deviceDetailsType;
}

export function* getStoreInfo({ payload: { deviceId } }: deviceType): any {
  console.info('getStoreInfo api request:', deviceId);
  yield callAPI(deviceId, ActionTypes.STORE_INFO, API.getStoreInfo, false);
}

export default function* root(): Object {
  yield all([takeLatest(ActionTypes.STORE_INFO_REQUEST, getStoreInfo)]);
}
